export const toolBoxIcon_1: string =
  "M11.9997,4.5 C18.7497,4.5 22.4997,12 22.4997,12 C22.4997,12 18.7497,19.5 11.9997,19.5 C5.2497,19.5 1.4997,12 1.4997,12 C1.4997,12 5.2497,4.5 11.9997,4.5 Z M11.9997,6 C7.3797,6 4.2717,10.305 3.2277,12 C4.2702,13.69275 7.37895,18 11.9997,18 C16.6197,18 19.72845,13.695 20.7717,12 C19.7292,10.30725 16.62045,6 11.9997,6 Z M12.00045,7.5 C14.4822,7.5 16.50045,9.51825 16.50045,12 C16.50045,14.48175 14.4822,16.5 12.00045,16.5 C9.5187,16.5 7.50045,14.48175 7.50045,12 C7.50045,9.51825 9.5187,7.5 12.00045,7.5 Z M12.00045,9 C10.3437,9 9.00045,10.34325 9.00045,12 C9.00045,13.65675 10.3437,15 12.00045,15 C13.6572,15 15.00045,13.65675 15.00045,12 C15.00045,10.34325 13.6572,9 12.00045,9 Z";
export const toolBoxIcon_2: string =
  "M 11.265613,14.877095 C 10.4228,14.656129 9.7432298,14.100581 9.340465,13.303288 8.8778329,12.387484 8.9430786,11.256237 9.5084512,10.390697 9.9020482,9.7881312 10.637116,9.2610131 11.303292,9.1036143 c 1.028429,-0.2429892 2.092709,0.07327 2.8345,0.8422956 0.885562,0.9180741 1.081305,2.1994711 0.514279,3.3666351 -0.373994,0.769826 -1.146616,1.390976 -1.96932,1.583234 -0.387877,0.09064 -1.032557,0.08214 -1.417138,-0.01868 z";
export const toolBoxIcon_3: string =
  "M 10.898846,17.896183 C 8.2349772,17.461957 5.6754409,15.586838 3.6458647,12.582642 3.1921725,11.911083 3.1791079,12.077336 3.7497029,11.261263 4.34004,10.416955 4.8494829,9.8069143 5.5581986,9.095651 6.6086197,8.0414541 7.4313531,7.4283168 8.5257223,6.8841211 10.222849,6.0401928 11.882422,5.8230491 13.633554,6.2157961 16.08148,6.764821 18.480874,8.6312023 20.400925,11.47983 l 0.330953,0.491009 -0.06709,0.138785 c -0.235056,0.486221 -1.35652,1.914359 -2.117135,2.696082 -1.590829,1.634979 -3.275545,2.633444 -5.104803,3.025415 -0.566123,0.121308 -1.977506,0.157404 -2.544001,0.06506 z m 1.786586,-1.432634 c 1.385684,-0.208887 2.66432,-1.112228 3.297802,-2.32986 0.366039,-0.703573 0.478015,-1.138807 0.507391,-1.972147 0.01917,-0.543949 0.0088,-0.719634 -0.06299,-1.064135 C 16.236095,10.177972 15.86302,9.493607 15.183219,8.8146618 14.322465,7.9549939 13.418368,7.5557055 12.216839,7.5045806 11.572172,7.4771501 11.164131,7.5264284 10.619632,7.6974718 8.6047697,8.3304005 7.2656753,10.38061 7.5076281,12.46208 c 0.1289248,1.109114 0.5722804,2.023346 1.3427309,2.768811 1.0443034,1.010436 2.40595,1.448092 3.835073,1.232658 z";

export const DARK = "dark";
export const BLACK = "#000000";
export const WHITE = "#FFFFFF";
export const EMPTY = "empty";

export type ReferencePointColumn = {
  id: string;
  name: string;
  correspondingPointId?: string;
  correspondingX: number;
  correspondingY: number;
  correspondingZ: number;
  x: number;
  y: number;
  z: number;
  dx: number;
  dy: number;
  dz: number;
  use: boolean;
  timeStamp: Date;
};

export type CoordinatePointColumn = {
  id: string;
  pointName: string;
  x: number;
  y: number;
  z: number;
  timeStamp: Date;
};

export enum ECoordinateTransformMode {
  INPUT = "input",
  TRANSFORM = "transform",
  VERIFICATION = "verification",
}

export interface SliderRange {
  max: Number;
  min: Number;
  step: Number;
}

export enum ECoordInputMode {
  FILE = "FILE",
  ROVER = "ROVER",
}

export const RANGE_COORD = 0.3;

export type VerificationPointColumn = {
  id: string;
  name: string;
  correspondingPointId?: string;
  trueX: number;
  trueY: number;
  trueZ: number;
  x: number;
  y: number;
  z: number;
  dx: number;
  dy: number;
  dz: number;
  use: boolean;
  timeStamp: Date;
};
